import { Application } from '@hotwired/stimulus';
import registerCustomElement from 'custom-elements/helpers/registerCustomElement';

const application = Application.start();

/**
 * Asynchronously import and register the various stimulus controllers needed by the calendar system.
 * @async
 * @function loadStimulusControllers
 * @returns {Promise<void>}
 */
async function loadStimulusControllers() {
  const SkdEventForm = (await import('../schedules/controllers/skd_event_form_controller')).default;
  application.register('skd-event-form', SkdEventForm);

  const SkdEventUpdateType = (await import('../schedules/controllers/skd_event_update_type_controller')).default;
  application.register('skd-event-update-type', SkdEventUpdateType);

  const SkdEventModeType = (await import('../schedules/controllers/skd_event_mode_type_controller')).default;
  application.register('skd-event-mode-type', SkdEventModeType);
}
/**
 * Asynchronously loads the various modules used by the main calendar module.
 * @async
 * @function loadModulesCalendar
 * @returns {Promise<void>} - Resolves when the module is loaded.
 */
async function loadModulesCalendar() {
  // Load custom elements from the old schedule system
  await import('../schedules/elements/patient_attendance_element');
  await import('../schedules/elements/patient_checkin_element');
  await import('../schedules/elements/patient_list_element');
  // Load some newer stuff
  await import('./filters');
  await import('./undo');
}
/**
 * Asynchronously loads the administrators' calendar module.
 * @async
 * @function loadAdministratorsCalendar
 * @returns {Promise<void>} - Resolves when the module is loaded.
 */
async function loadAdministratorsCalendar() {
  await import('./administrators');
}
/**
 * Event listener for the 'turbolinks:load' event.
 * Loads the appropriate calendar module and Stimulus controllers.
 * @event turbolinks:load
 * @param {Event} event - The event object.
 */
document.addEventListener('turbolinks:load', async (event) => {
  registerCustomElement(require.context('../custom-elements', true, /recurring-select-element\.ts$/));
  registerCustomElement(require.context('../custom-elements/checkbox', true, /-element\.ts$/));

  // Load Stimulus controllers first
  await loadStimulusControllers();
  // Load all the other modules
  await loadModulesCalendar();

  // Check if the administrators' calendar element is present
  if (document.getElementById('administrators_calendar')) {
    await loadAdministratorsCalendar();
  }

  if (document.querySelector('therapist-calendar')) {
    await import('./therapists');
  }
});
